import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IResourceCostsStatistics } from "../domain/IResourceCostsStatistics";
import { IYearRequestParams } from "../domain/IYearRequestParams";
import { StatisticsService } from "../services/statistics.service";

interface ResourcesStatisticsState {
  loading: boolean;
  statistics?: IResourceCostsStatistics;
  error: any;
}

const initialState: ResourcesStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getResourcesStatistics = createAsyncThunk(
  "Statistics/getResourcesStatistics",
  async (year?: IYearRequestParams) => {
    try {
      const result = await StatisticsService.getResourceCostsStatistics(year);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);

export const ResourcesStatisticsSlice = createSlice({
  name: "ResourcesStatistics",
  initialState: initialState,
  reducers: {
    setStatistics: (state, action: PayloadAction<IResourceCostsStatistics>) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getResourcesStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getResourcesStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ? action.payload : undefined;
    });
    builder.addCase(getResourcesStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.statistics.resources;

export const { setError } = ResourcesStatisticsSlice.actions;

export default ResourcesStatisticsSlice.reducer;
